import { BaseService } from '@myhealth-raccoon/services';

import { authService } from '../auth';
import { Place, FullAddress } from './types';

class AddressService extends BaseService {
    get Authorization() {
        return authService.Authorization;
    }

    constructor() {
        super('api/AddressSearch', import.meta.env.VITE_COMMS_API_URL);
    }

    public async GetSearchPlace(input: string) {
        return await this.get<Place[]>(`search?${new URLSearchParams({ input })}`);
    }

    public async GetFullAddress(placeId: string) {
        return await this.get<FullAddress>(`details?${new URLSearchParams({ placeId })}`);
    }
}

export const addressService = new AddressService();
export * from './types';
